import createAccessor from '../utils/create-accessor';
import selectors from '../selectors';

export default {
  getActiveSubscriptions: createAccessor(selectors.getActiveSubscriptions),
  getSubscriptionList: createAccessor(selectors.getSubscriptionList),
  getEcommercePlans: createAccessor(selectors.getEcommercePlans),
  getHostingPackages: createAccessor(selectors.getHostingPackages),
  getCurrentPackage: createAccessor(selectors.getCurrentPackage),
  getCurrentPackageType: createAccessor(selectors.getCurrentPackageType),
  getCurrentPackageProperties: createAccessor(selectors.getCurrentPackageProperties),
  getCurrentPackageTrialStatus: createAccessor(selectors.getCurrentPackageTrialStatus),
  getTopAvailableEcommercePlan: createAccessor(selectors.getTopAvailableEcommercePlan),
  getTopAvailableHostingPackage: createAccessor(selectors.getTopAvailableHostingPackage),
  getHostingUpgradeAvailability: createAccessor(selectors.getHostingUpgradeAvailability),
  getActiveEcommerceSubscription: createAccessor(selectors.getActiveEcommerceSubscription),
  getActiveEcommerceSubscriptionType: createAccessor(selectors.getActiveEcommerceSubscriptionType),
  getActiveHostingSubscription: createAccessor(selectors.getActiveHostingSubscription),
  getActiveSubscriptionById: createAccessor(selectors.getActiveSubscriptionById),
  getLastDeprovisionedEcommerceSubscription: createAccessor(
    selectors.getLastDeprovisionedEcommerceSubscription
  ),
  getCurrentEcommercePlan: createAccessor(selectors.getCurrentEcommercePlan),
  getMostPopularHostingPackage: createAccessor(selectors.getMostPopularHostingPackage),
  getMostPopularEcommercePlan: createAccessor(selectors.getMostPopularEcommercePlan),
  getLowestAvailablePaidHostingPackage: createAccessor(
    selectors.getLowestAvailablePaidHostingPackage
  ),
};
